import { createAction, props } from "@ngrx/store";

export const loadAppInsights = createAction("[Telemetry] Load App Insights");

export const initializeWebVitals = createAction(
  "[Telemetry] Initialize Web Vitals"
);

export const logPageView = createAction(
  "[Telemetry] Log Page View",
  props<{ name?: string; url?: string }>()
);

export const logEvent = createAction(
  "[Telemetry] Log Event",
  props<{ name: string; properties?: { [key: string]: any } }>()
);

export const logMetric = createAction(
  "[Telemetry] Log Metric",
  props<{
    name: string;
    average: number;
    properties?: { [key: string]: any };
  }>()
);

export const logException = createAction(
  "[Telemetry] Log Exception",
  props<{ exception: Error; severityLevel?: number }>()
);

export const logTrace = createAction(
  "[Telemetry] Log Trace",
  props<{ message: string; properties?: { [key: string]: any } }>()
);
